import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  required,
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-46">
      <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-47">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-48">*</span>}
      </label>
      <input className={`w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-shadow ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300'} ${className}`} required={required} {...props} data-id="element-49" />
      {error && <p className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-50">
          {error}
        </p>}
    </div>;
}